import React from "react";
import { Col, Row } from "react-bootstrap";

import FeatureImage from "../../assets/images/Home/Features/leftaddimage.png";

const Feature = () => {
  const features = [
    {
      title: "Search",
      description:
        "Find businesses by using a simple keyword search, or narrow it down with our filter options ",
      id: 1,
    },
    {
      title: "Home Page",
      description:
        "Stay up to date with the businesses you follow so you don’t miss out on their latest promotions and content",
      id: 2,
    },
    {
      title: "Explore",
      description:
        "Simply scroll through business reels for inspiration and further discovery",
      id: 3,
    },
    {
      title: "Message",
      description: "Directly message businesses for convenience and reference",
      id: 4,
    },
    {
      title: "Business profiles",
      description:
        "View business profiles to gain insight into their services or products, view their content, read reviews and ratings and get directions to their location. And much more",
      id: 5,
    },
    {
      title: "User friendly",
      description:
        "Bizooka has been designed for people of all ages and technical ability, simplifying your business search",
      id: 6,
    },
    {
      title: "Affordable marketing",
      description:
        "An unlimited business profile is only $29 per month, or a free account which comes with limitations",
      id: 7,
    },
    {
      title: "Sponsored ads",
      description:
        "Wanting even more exposure? You have options for banner ads and native ads that are set to your budget",
      id: 8,
    },
  ];
  return (
    <>
      <div className="features-component container" id="feature">
        <Row>
          <Col className="feature-image mt-5" xs={12} md={12} lg={6}>
            <img src={FeatureImage} alt="" />
          </Col>
          <Col className="feature-details mt-5" xs={12} md={12} lg={6}>
            <div className="content mt-1">
              <h5>Features</h5>
              <h1>
                Business Search Simplified <span>Bizooka</span>
              </h1>
              <div className="feature-list mt-5">
                {features.map((feature, index) => (
                  <div key={feature.id} className="feature-item mb-3">
                    <input
                      type="radio"
                      id={`feature${index}`}
                      name="feature"
                      // defaultChecked={index === 1}
                    />
                    <label htmlFor={`feature${index}`}>
                      <h3>{feature.title}</h3>
                      <p className="mb-2">{feature.description}</p>
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
export { Feature };
